<template>
  <div class="search-wrap">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem>
          <Input
            v-model="searchConds.inName"
            placeholder="请输入转入方"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <Input
            v-if="portOrg != 2"
            v-model="searchConds.outName"
            placeholder="请输入转出方"
            clearable
          ></Input>
          <span v-else>{{ searchConds.outName }}</span>
        </FormItem>
        <FormItem>
          <Select
            v-model="searchConds.outFeeType"
            placeholder="请选择支出类型"
            clearable
            style="width: 200px"
            :transfer="true"
          >
            <Option
              v-for="item in payTypes"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            type="datetimerange"
            placeholder="选择发起开始时间 至 选择发起结束时间"
            style="width: 330px"
            :value="dateTime"
            :transfer="true"
            on-date-time-change
            @on-change="onDateTimeChange"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <Select
            v-model="searchConds.transSts"
            placeholder="请选择状态"
            clearable
            style="width: 200px"
            :transfer="true"
          >
            <Option
              v-for="item in status"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <div style="margin-right: 40px">
            <CascaderYearTerms
              ref="cascaderYearTermsRef"
              :clearable="true"
              :placeholder="`请选择学期`"
              :cache-year-terms="yearTerms"
              :need-init-data="false"
            >
            </CascaderYearTerms>
          </div>
        </FormItem>
        <Button type="primary" style="margin-right: 16px" @click="handleSearch"
          >查询</Button
        >
        <Button @click="handleReset">重置</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
export default {
  components: {
    CascaderYearTerms
  },
  data() {
    return {
      searchConds: {
        inName: '',
        outName: '',
        outFeeType: '',

        dataTimeBegin: '',
        dataTimeEnd: '',
        transSts: '1'
      },
      payTypes: [{
        value: '3',
        label: '教师工资'
      }, {
        value: '2',
        label: '其他支出'
      }],
      status: [{
        value: '1',
        label: '交易成功'
      }, {
        value: '2',
        label: '交易失败'
      }, {
        value: '3',
        label: '交易处理中'
      }],
      dateTime: [],
      portOrg: localStorage.getItem('portOrg'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      yearTerms: [],
    };
  },
  created() {
    if (this.portOrg == 2) {
      this.searchConds.outName = this.userInfo.orgName;
    }
    if (this.$route.query.schoolname) {
      this.searchConds.outName = this.$route.query.schoolname;
    }
    this.$nextTick(() => {
      this.handleSearch();
    })
  },
  methods: {
    handleSearch() {
      const searchConds = {};
      for (const k in this.searchConds) {
        searchConds[k] = this.searchConds[k] ? this.searchConds[k] : null;
      }
      const yearTerms = this.$refs.cascaderYearTermsRef.getResult();
      if (yearTerms.length > 1) {
        searchConds.yearCode = yearTerms[0];
        searchConds.termCode = yearTerms[1];
      }
      this.$emit('on-search', searchConds);
    },
    handleReset() {
      this.$refs.cascaderYearTermsRef && this.$refs.cascaderYearTermsRef.handleDefault();
      for (const k in this.searchConds) {
        this.searchConds[k] = '';
      }
      if (this.portOrg == 2) {
        this.searchConds.outName = this.userInfo.orgName;
      }
      this.dateTime = [];
      this.handleSearch();
    },
    onDateTimeChange(time) {
      this.searchConds.dataTimeBegin = time[0];
      this.searchConds.dataTimeEnd = time[1];
    }
  }
};
</script>

<style></style>
